import angular from 'angular';

const userInstrumentStoreFactory = function UserInstrumentStoreFactory($rootScope, $q, $log, Dispatcher, StoreStates) {
        "ngInject";
        let
            instrumentList,
            InstrumentListState = StoreStates.STORE_EMPTY,
            walletBalancePending = false,
            lastWalletBalance,
            lastWalletAccountBalance,
            lastWalletAccountBalanceState = StoreStates.STORE_EMPTY,
            prepaidCardBalancePending = false,
            lastprepaidCardBalance,
            prepaidCardPanState = StoreStates.STORE_EMPTY,
            prepaidCardPan;

        const notifyChange = function() {
            $rootScope.$broadcast("USERINSTRUMENT_ACTION_UPDATE");
        };

        const notifyFail = function() {
            $rootScope.$broadcast("USERINSTRUMENT_ACTION_UPDATE_FAIL");
        };

        const notifyWalletBalanceChange = function() {
            $rootScope.$broadcast("USERINSTRUMENT_WALLETBALANCE_UPDATE");
        };

        const notifyCardBalanceChange = function() {
            $rootScope.$broadcast("USERINSTRUMENT_CARDBALANCE_UPDATE");
        };

        const notifyRequestPrepaidCardSuccess = function(data) {
            $rootScope.$broadcast("USERINSTRUMENT_REQUEST_PREPAID_CARD_SUCCESS", data);
        };

        const notifyRequestPrepaidCardFail = function(reason) {
            $rootScope.$broadcast("USERINSTRUMENT_REQUEST_PREPAID_CARD_FAIL", reason);
        };

        const notifyPrepaidCardPanChange = function() {
            $rootScope.$broadcast("USERINSTRUMENT_CARDPAN_UPDATE");
        };

        const dispatcherToken = Dispatcher.register(function(action) {
            switch (action.actionType) {
                case "USERINSTRUMENT_LOAD_INSTUMENT_LIST":
                    instrumentList = action.data;
                    InstrumentListState = action.state;
                    notifyChange();
                    break;
                case "USERINSTRUMENT_START_LOAD_INSTUMENT_LIST":
                    InstrumentListState = action.state;
                    break;
                case "USERINSTRUMENT_LOAD_INSTUMENT_LIST_FAIL":
                    instrumentList = undefined;
                    InstrumentListState = action.state;
                    notifyFail();
                    break;
                case "USERINSTRUMENT_START_WALLETBALANCE_LOAD":
                    walletBalancePending = true;
                    break;
                case "USERINSTRUMENT_WALLETBALANCE_LOAD":
                    walletBalancePending = false;
                    if(typeof action.data !== "object"){
                      lastWalletBalance = parseFloat(action.data);
                    } else if(typeof action.data.disponibile !== "undefined"){
                      lastWalletBalance = action.data.disponibile;
                      lastWalletAccountBalance = action.data;
                      // TODO ottimizza!!!
                      lastWalletAccountBalanceState = StoreStates.STORE_VALID;
                    }
                    notifyWalletBalanceChange();
                    break;
                case "USERINSTRUMENT_WALLETBALANCE_LOAD_FAIL":
                    walletBalancePending = false;
                    lastWalletBalance = undefined;
                    notifyWalletBalanceChange(); // notify fail
                    break;
                case "USERINSTRUMENT_START_CARDBALANCE_LOAD":
                    prepaidCardBalancePending = true;
                    break;
                case "USERINSTRUMENT_CARDBALANCE_LOAD":
                    prepaidCardBalancePending = false;
                    lastprepaidCardBalance = action.data;
                    notifyCardBalanceChange();
                    break;
                case "USERINSTRUMENT_CARDBALANCE_LOAD_FAIL":
                    prepaidCardBalancePending = false;
                    lastprepaidCardBalance = undefined;
                    notifyCardBalanceChange(); // notify fail
                    break;
                case "USERINSTRUMENT_REQUIRE_NEW_PREPAID_CARD_START":
                    // nop;
                    break;
                case "USERINSTRUMENT_REQUIRE_NEW_PREPAID_CARD_SUCCESS":
                    InstrumentListState = action.state;
                    notifyRequestPrepaidCardSuccess(action.data);
                    break;
                case "USERINSTRUMENT_REQUIRE_NEW_PREPAID_CARD_FAIL":
                    notifyRequestPrepaidCardFail(action.data);
                    break;
                case "USERINSTRUMENT_CARDPAN_LOAD_START":
                    prepaidCardPanState = action.state;
                    break;
                case "USERINSTRUMENT_CARDPAN_LOAD":
                    prepaidCardPanState = action.state;
                    prepaidCardPan = action.data;
                    notifyPrepaidCardPanChange();
                    break;
                case "USERINSTRUMENT_CARDPAN_LOAD_FAIL":
                    prepaidCardPanState = action.state;
                    prepaidCardPan = undefined;
                    notifyPrepaidCardPanChange();
                    break;
                case "GLOBAL_CLEAN":
                    instrumentList = undefined;
                    lastWalletBalance = undefined;
                    lastprepaidCardBalance = undefined;
                    InstrumentListState = StoreStates.STORE_EMPTY;
                    prepaidCardPanState = StoreStates.STORE_EMPTY;
                    prepaidCardPan = undefined;
                    break;
                default:
                    //noOp
                    break;
            }
        });
        return {
            getUserInstrumentList: function() {
                return instrumentList;
            },
            getUserInstrumentListState: function() {
                return InstrumentListState;
            },
            getWallet: function() {
                let result = undefined;
                if (instrumentList === undefined) {
                    return undefined;
                }
                angular.forEach(instrumentList, function(single) {
                    if (single.bankAccountResource) {
                        result = single;
                    }
                });
                if(result === undefined){
                    angular.forEach(instrumentList, function(single) {
                        if (single.svaResource) {
                            result = single;
                        }
                    });
                }
                return result;
            },
            getPrepaidCard: function() {
                let result = undefined;
                if (instrumentList === undefined) {
                    return undefined;
                }
                angular.forEach(instrumentList, function(single) {
                    if (single.prepaidCardResource) {
                        result = single;
                    }
                });
                return result;
            },
            isWalletBalancePending: function() {
                return walletBalancePending;
            },
            isPrepaidCardBalancePending: function() {
                return prepaidCardBalancePending;
            },
            getLastWalletBalance: function() {
                return lastWalletBalance;
            },
            getLastWalletAccountBalance: function() {
                return lastWalletAccountBalance;
            },
            getLastWalletAccountBalanceState: function() {
                return lastWalletAccountBalanceState;
            },
            getLastPrepaidCardBalance: function() {
                return lastprepaidCardBalance;
            },
            getPrepaidCardPanState: function() {
                return prepaidCardPanState;
            },
            getPrepaidCardPan: function() {
                if (prepaidCardPan === undefined){ return '--'; }
                return `**** **** **** ${prepaidCardPan}`;
            },
            forceExpired: function() {
                InstrumentListState = StoreStates.STORE_EXPIRED;
            },
            getDispatcherToken: function() {
                return dispatcherToken;
            }
        };
    }

export default userInstrumentStoreFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/userInstrumentStore.factory.js
 **/